export const FETCH_FLEET = 'FETCH_FLEET'
export const FETCH_FLEET_ERROR = 'FETCH_FLEET_ERROR'
